var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container"},[_c('LayoutPreview'),_c('AsidePreview'),_c('MenuPreview'),_c('MenuItemPreview'),_c('ContactPreview'),_c('ImageLoaderPreview'),_c('EmptyPreview'),_c('AvatarPre'),_c('IconPre'),_c('PaginationPre'),_c('el-button',{on:{"click":_vm.test}},[_vm._v("test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }